import gql from "graphql-tag";

export default gql`
  query getSellerVerifications($userId: Int!) {
    allSellerVerifications(condition: { userId: $userId }) {
      nodes {
        id
        userId
        verificationType
        verificationStatus
        verifiedAt
        expiresAt
        rejectionReason
        createdAt
      }
    }
  }
`;
